<template>
	<component :is="layout" :api="api" :connected="connected">
	</component>
</template>

<script>
import Layout from './components/Layout.vue'
import {ApiConnection, ApiStateManager, VueComponentApiProxy} from './api.js'

const jsonrpc = new ApiConnection()
const api = new ApiStateManager(jsonrpc)

export default {
	mounted: function() {
		jsonrpc.onConnect(() => {
			this.connected = true
		});
		jsonrpc.onDisconnect(() => {
			this.connected = false
		});

	},
	data: function() {
		return {
			layout: Layout,
			api: new VueComponentApiProxy(this, api),
			connected: jsonrpc.connected,
		}
	},
}
</script>
